const caFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'CAD',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { caFormats };
